import { render, staticRenderFns } from "./DiscountForm.vue?vue&type=template&id=0f548676&scoped=true&lang=html&"
import script from "./DiscountForm.vue?vue&type=script&lang=js&"
export * from "./DiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f548676",
  null
  
)

export default component.exports